import React from 'react'
import PropTypes from 'prop-types'
import { StaticQuery, graphql, Link } from 'gatsby'

import Header from './header'
import './layout.css'

let year = new Date().getFullYear()

const Layout = ({ children }) => (
  <StaticQuery
    query={graphql`
      query SiteTitleQuery {
        site {
          siteMetadata {
            title
          }
        }
      }
    `}
    render={data => (
      <>
        <div id="wrap">
          <Header siteTitle={data.site.siteMetadata.title} />

          <div id="content-wrap">
            <div id="main">{children}</div>
          </div>

          <div id="footer">
            <div className="footer-content">
              <div className="footer-info">
                <p className="footer-company">
                  <strong>Lawrence Hoffman, CPA, PC</strong>
                </p>
                <p className="footer-contact">
                  <a href="tel:+15166259051">(516) 625-9051</a>
                </p>
                <p className="footer-portal">
                  <a
                    href="https://lhcpapc.securefilepro.com"
                    className="btn btn-secondary btn-small footer-portal-btn"
                  >
                    Customer Portal
                  </a>
                </p>
              </div>
              <div className="footer-cta">
                <Link to="/contact/" className="btn btn-primary btn-small">
                  Get Started
                </Link>
              </div>
              <div className="footer-legal">
                <p>
                  &copy; {year} Lawrence Hoffman, CPA, PC &amp; Lawall Service
                  Corp.
                </p>
              </div>
            </div>
          </div>
        </div>
      </>
    )}
  />
)

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
